import * as browser from './vipa/browser';
import * as rendering from './vipa/rendering';
import { VariantsTable } from "./vipa/variantsTable";

import * as AdvancedSearch from './cases/AdvancedSearch';
import * as AddToCart from './cases/AddToCart';
import * as Dropzone from './cases/Dropzone';
import * as EmptyCart from './cases/EmptyCart';
import * as LoadNews from './cases/LoadNews';
import * as Maintenance from './cases/Maintenance';
import * as RemoveCartItem from './cases/RemoveCartItem';
import * as RemoveInvite from './cases/RemoveInvite';
import * as Sliders from './cases/Sliders';
import * as SystemMessage from './cases/SystemMessage';
import * as ToggleProductFavourite from './cases/ToggleProductFavourite';
import * as UpdateCart from './cases/UpdateCart';
import * as UpdateCartItem from './cases/UpdateCartItem';
import * as UpdateCustomFile from './cases/UpdateCustomFile';
import * as VariantAddToCart from './cases/VariantAddToCart';
import * as VariantCheckAvailability from './cases/VariantCheckAvailability';

declare var Foundation: any;
declare var Modernizr: any;

// Inits
new AddToCart.Case;
new Dropzone.Case;
new EmptyCart.Case;
new LoadNews.Case;
new Maintenance.Case;
new RemoveCartItem.Case;
new RemoveInvite.Case;
new AdvancedSearch.Case;
new SystemMessage.Case;
new ToggleProductFavourite.Case;
new UpdateCart.Case;
new UpdateCartItem.Case;
new UpdateCustomFile.Case;
new VariantAddToCart.Case;
new VariantCheckAvailability.Case;

// TODO: Remove because webp is now granted
// TODO: Remove Modernizr if no longer used
Modernizr.on('webp', function (result: any) {
    if (result) {
        $(".webp-support").addClass("webp")
    } else {
        $(".webp-support").addClass("no-webp")
    }
});

function openVariant(link: string, quantity_field_selector: string) {
    let url = $(link).data("url");

    if (quantity_field_selector !== undefined) {
        let quantity = $(quantity_field_selector).val();
        url += `?quantity=${quantity}`;
    }

    let modal = $("#modal-variant");
    if (url) {
        modal.html("Loading...");
        $.ajax(url).done(function (response) {
            modal.html(response);
            new Foundation.Orbit($(".reveal .orbit"), {});
        });
    }
}

$(function () {
    Sliders.init();
    globalThis.VariantsTable = VariantsTable;
    globalThis.openVariant = openVariant;
    globalThis.browser = browser;
    globalThis.rendering = rendering;
});

// Check if browser is Internet Explorer
$(function () {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    // if Internet Explorer
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        $(".browser_outdated").removeClass("hide");
    }
});
